import {ApiService} from "./api.service";
import {ApplicationHelper} from "../helpers/ApplicationHelper";

export class OrganizationService extends ApiService {

  constructor() {
    super();
    this.endpoint = "/organizations";
  }

  async show(id) {
    return super.show(id);
  }

  async update(id, params) {
    return super.update(id, params);
  }

  async getPermissions(id) {
    return await this.get(`${this.endpoint}/${id}/page_permissions`);
  }

  async getDonationTargets(id, includeInvalid = false, purpose) {
    const params = new URLSearchParams();
    params.set('include_invalid', includeInvalid);
    params.set('purpose', purpose);

    return await this.get(`${this.endpoint}/${id}/donation_targets`, params);
  }

  async downloadTemplate(id) {
    const url = `${this.endpoint}/${id}/export_model_template`;
    const fileName = `team_member_template.xlsx`;
    return super.downloadFile(url, fileName, 'text/csv');
  }

  // Different than create, will make a user record if none exists
  // TOOD email invite user after create
  async uploadMember(id, params) {
    const url = `${this.endpoint}/${id}/add_or_invite`;
    return super.post(url, params);
  }

  async getDonatable(orgId, params) {
    let url = `${this.endpoint}/${orgId}/donation_target`;
    return await this.get(url, params);
  }
}
